export default function Footer() {
  const footerLinks = [
    { label: '秒开抢先看', href: '#media' },
    { label: '常见问题', href: '#faq' },
    { label: '热门话题', href: '#topics' },
    { label: '精选专题', href: '#cards' },
    { label: '焦点专题', href: '#carousel' },
    { label: '影片索引', href: '#index' },
    { label: '关于我们', href: '#about' },
    { label: '联系我们', href: '#contact' },
  ];

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="mx-auto px-4 md:px-6 max-w-[1400px] py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-xl font-heading font-bold text-primary-500 tracking-wide">
                8848<span className="text-foreground-900">影院</span>
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              主打不缓冲流畅播放体验，秒开视频无卡顿，极速观影畅享高清画质，海量影视资源免费在线观看。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h3>
            <div className="grid grid-cols-2 gap-2">
              {footerLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-500">更多合作伙伴即将入驻，敬请期待</p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            &copy; 2026 8848影院. 本站内容仅供学习交流，请于24小时内删除.
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}